/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FirstInstallmentDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function FirstInstallmentDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/FirstInstallmentDate",
  onChange
  
}) {
let payorFirstDueDateValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
path: 'first_due_date',
format: fromFormat.dateISOIn,
})
let payorFirstDueDateChangeData = fromData.useDataChange({ viewPath,
context: 'payor',
path: 'first_due_date',
formatOut: fromHelpers.formatOutDate,
})
let payorPaymentPlanLengthValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
path: 'payment_plan_length',
format: fromFormat.not,
})
let onBlur = fromHelpers.useOnBlur({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 maxWidth={200}
 type="text"
 position="relative"
 data="payor.first_due_date"
 format="/Data/format.js dateISOIn"
 formatOut="helpers.js formatOutDate"
 value={payorFirstDueDateValueData}
 onChange={payorFirstDueDateChangeData}
 onBlur={onBlur}
 autoFocus={false}
 data="payor.payment_plan_length"
 format="/Data/format.js not"
 disabled={payorPaymentPlanLengthValueData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Installment will start on"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}